export default __webpack_public_path__ + "static/media/gon1_assembled_potato.fa.a945fb2f.gz";